const LIGHT_BACKGROUNDS = ["white", "yellow"];

export const useTextColor = (backgroundColor: string): string => {
  return LIGHT_BACKGROUNDS.includes(backgroundColor) ? "black" : "white";
};
